import * as actions from '../../types';
import CMX from "../../../api";
import { getCheckoutContext, getCheckoutNipCode, getFingerprint } from "../../../reducers";
import { getLoyaltyCheckoutParams, getSessionCheckoutParams } from "./payment";
import { dialogAlert } from '../dialogs';
import { CHECKOUT_CONTEXT_LOYALTY, CHECKOUT_CONTEXT_LOYALTY_PACKAGES, CHECKOUT_CONTEXT_SIGN_UP } from '../checkout';

export const fetchStripeRedirectUrl = (extraParams) => (dispatch, getState) => {
  const state = getState();
  const params = getSessionCheckoutParams(getState());
  params.nip = getCheckoutNipCode(state);
  //params.fingerprint = getFingerprint(state);

  if (extraParams && ('user_info' in extraParams)) {
    params.user_info = extraParams.user_info;
  }

  dispatch(getStripeRedirectUrlIsProcessing());

  CMX.post('buy/getPaymentUrl', params)
      .then(data => dispatch(getStripeRedirectUrlSuccess(data)))
      .catch(error => dispatch(getStripeRedirectUrlError(error)));
};

const getStripeRedirectUrlIsProcessing = () => ({
  type: actions.GET_STRIPE_URL
});

const getStripeRedirectUrlSuccess = data => dispatch => {
  dispatch({
    type: actions.GET_STRIPE_URL_SUCCESS,
    data,
  });
  /*dispatch({
    type: actions.CHECKOUT_STRIPE_OPEN,
    url: data.url
  });

  openStripeWindow(data.url, dispatch);*/
};

const getStripeRedirectUrlError = (error) => dispatch => {
  dispatch(dialogAlert(error.message || 'Ocurrió un error. Por favor, inténtalo nuevamente.'));
  dispatch({
    type: actions.GET_STRIPE_URL_ERROR
  });
};
  

const openStripeWindow = (url, dispatch) => {
  const win = window.open(url);
  let timer = setInterval(function() {
    if (!win || !win.window || win.closed) {
      clearInterval(timer);
      dispatch(requestFailed());
      return;
    }

    try {
      win.postMessage({message: "requestCinemexSmartResult"}, "*");
    } catch (e) {}
  }, 1000);

  window.addEventListener("message", function(e) {
    if (e.data.message === "deliverCinemexSmartResult") {
      console.log('message', e);
      clearInterval(timer);
      
      if (e.data.result.success) {
        dispatch(requestSuccess(e.data.result));
      } else {
        dispatch(requestFailed());
      }
      if (e.source && typeof (e.source as Window).close === 'function') {
        (e.source as Window).close();
      }
    }
  });
};

const requestSuccess = data => ({
  type: actions.CHECKOUT_STRIPE_SUCCESS,
  data
});

const requestFailed = () => dispatch => {
  //dispatch(dialogAlert('Has cancelado tu compra con Masterpass.'));
  dispatch({
    type: actions.CHECKOUT_STRIPE_ERROR,
  })
};

export const createStripePaymentIntent = (intentParams = {}) => (dispatch, getState) => {
  const state = getState();
  const context = ('context' in intentParams) ? intentParams.context : getCheckoutContext(state);
  let url: string;
  let params: any = {};
  
  // @todo Extract switch() to a separate function.
  // @todo Refactor each case to a separate function.
  switch (context) {
    case CHECKOUT_CONTEXT_SIGN_UP:
      url ='register/stripe/createPaymentIntent';
      params = ('data' in intentParams) ? intentParams.data : {};
      params.fingerprint = getFingerprint(state);
      break;
    case CHECKOUT_CONTEXT_LOYALTY:
      url = '/ie/payment/stripe/createPaymentIntent';
      params = getLoyaltyCheckoutParams(state);
      params = Object.assign(params, intentParams);
      break;
    case CHECKOUT_CONTEXT_LOYALTY_PACKAGES:
      url = '/loyalty/packages/stripe/createPaymentIntent';
      params = ('data' in intentParams) ? intentParams.data : {};
      if (('name' in intentParams) && ('email' in intentParams)) {
        params.payment = {
          name: intentParams.name,
          email: intentParams.email
        };
      }
      break;
    default:
      url = 'buy/stripe/createPaymentIntent';
      params = getSessionCheckoutParams(state);
      params = Object.assign(params, intentParams);
      break;
  }
  
  dispatch(createStripePaymentIntentIsProcessing());
  
  return CMX.post(url, params)
    .then(data => {
      dispatch(createStripePaymentIntentSuccess(data));
      return data;
    })
    .catch(error => dispatch(createStripePaymentIntentError(error)));
};

const createStripePaymentIntentIsProcessing = () => ({
  type: actions.STRIPE_CREATE_PAYMENT_INTENT
});

const createStripePaymentIntentSuccess = (data) => (dispatch) => {
  dispatch({
    type: actions.STRIPE_CREATE_PAYMENT_INTENT_SUCCESS,
    data
  });
}

const createStripePaymentIntentError = (error) => ({
  type: actions.STRIPE_CREATE_PAYMENT_INTENT_ERROR,
  error
});